import { createSelector } from '@reduxjs/toolkit'

import { ReduxState } from '../store'

export const selectWebapiJWT = createSelector(
  ({ webapiJWT }: ReduxState) => webapiJWT,
  (webapiJWT) => webapiJWT
)
